import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";

import css from './ModalSelectCourier.module.css';
import { clientsService } from "../../../../services/clients-services";

const ModalSelectCourier = () => {
    const { t } = useTranslation();
    const { register, watch } = useFormContext();
    const [couriers, setCouriers] = useState([]);
    const selectedCourier = watch('courier');

    useEffect(() => {
        // Fetch couriers
        const fetchCouriers = async () => {
            try {
                const couriersList = await clientsService.getAllCouriers();
                setCouriers(couriersList);
            } catch (error) {
                console.error('Error fetching couriers:', error);
            }
        };

        fetchCouriers();
    }, []);

    return (
        <div className={css.wrap}>
            <label htmlFor="courier">{t('courier')}</label>
            <select 
                id="courier" 
                name="courier" 
                {...register('courier')}
                defaultValue={selectedCourier}
            >
                <option value=""></option>
                {couriers.map(courier => (
                    <option 
                        key={courier.id} 
                        value={courier.clientName}
                        selected={courier.clientName === selectedCourier}
                    >
                        {courier.clientName}
                    </option>
                ))}
            </select>
        </div>
    );
};

export { ModalSelectCourier };